module.exports = __webpack_public_path__ + "static/media/cyberr.c312bd4c.png";